import { writable } from 'svelte/store';
export const client = writable(null);
export const clientId = writable(null);
export const remoteLocation = writable(null);
export const remoteTracks = writable({});
export const errorMessage = writable(null);
export const microphoneEnabled = writable(false);
export const otherMicrophoneEnabled = writable(false);
export const selectedCameraId = writable(null);
export const flipHorizontal = writable(false);
export const flipVertical = writable(false);
